var version = "10.30.6";

export { version as v };
//# sourceMappingURL=package-31d84618.js.map
